import { createAsyncThunk } from '@reduxjs/toolkit';
import Api, { FetchParams } from '../utils/Api';
import { blankOrString, mapBooleanToNumber } from '../utils/sagas';
import { defaultMenuProviderV2 } from './defaultMenuProviderV2';
import { setDayparts } from '../reducers/currentOrder/dayparts';

// This current new route is meant to be short lived, in phase two this route will be gone.
// We will be implementing a menu route that will only include information of what the consumer
// needs and only the top level items, and another route for fetching individual items.
export const fetchProcessedMenu = createAsyncThunk(
  '$fetchProcessedMenu',
  async (data: MenuProviderParams, { dispatch }) => {
    const {
      locationId,
      saleType,
      orderingProvider,
      defaultSelectedOnly = false,
    } = data;

    try {
      const path = [
        '/api/v1/stores/',
        locationId,
        '/processed-menu?',
        `&sale_type=${saleType}`,
        blankOrString(
          `&ordering_provider=${orderingProvider}`,
          orderingProvider == null,
        ),
        blankOrString(
          `&default_selected_only=${mapBooleanToNumber(defaultSelectedOnly)}`,
          !defaultSelectedOnly,
        ),
      ].join('');

      const requestParams: FetchParams = {
        path,
        method: 'GET',
      };

      const response = await Api.fetch(requestParams);

      const {
        menu,
        items,
        choiceSets,
        upsells,
        upsellTitle,
        categoryInfos,
        substitutionSets,
        dayparts,
      } = response.data;

      // Set dayparts into redux
      dispatch(setDayparts(dayparts));

      // Output contract of processMenuV2() kept same shape/order as this array.
      return [
        menu,
        items,
        choiceSets,
        upsells,
        upsellTitle,
        categoryInfos,
        substitutionSets,
      ];
    } catch (e) {
      console.error('[fetchProcessedMenu] error:', e);
    }
    return dispatch(defaultMenuProviderV2(data)).unwrap();
  },
);
